<template lang="html">
  <div style="display:flex; height: 100%;">
    <div class="content">
      <div class="settings-main">
        <div class="content-header">
          Benutzerhandbuch
        </div>
        <div class="tiles row mobile-padding-0">
          <div class="tile-wrapper">
            <div class="clear-tile">
              <div class="row">
                <div class="col-md-12">
                  <div class="small-tile-wrapper">
                    <div class="small-tile">
                      <p class="small-tile-title">
                        Sehr geehrte Nutzerin, sehr geehrter Nutzer,
                      </p>
                      <div class="row">
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            mit dieser Applikation möchte das DIGIMONDO-Team
                            Ihnen helfen, Ihre IoT-Plattform bestmöglich zu
                            nutzen, Ihre Sensoren immer im Blick zu haben und
                            aus den gemessenen Werten Handlungen folgen zu
                            lassen. In der Anleitung werden die Funktionsweisen
                            und die Bedienung der Applikation erklärt. Sollten
                            Sie darüber hinaus Fragen haben, während der
                            Bedienung einen Fehler finden oder einen
                            Verbesserungsvorschlag haben, freut sich unser
                            Support-Team über eine E-Mail an
                            <a href="mailto:support@digimondo.de"
                              >support@digimondo.de</a
                            >.
                          </p>
                          <p class="small-tile-text">
                            <span class="subheadline2"
                              >Ziel dieser Anwendung:</span
                            >
                            Das Ziel dieser Applikation ist es, Ihre tägliche
                            Arbeit zu vereinfachen, Sie bei der Entstehung
                            kritischer Betriebszustände frühzeitig zu
                            informieren und ggf. mit einem automatisierten Alarm
                            zu warnen. Dies funktioniert folgendermaßen:<br />
                            In Gebäuden und auf Geländen werden verschiedene
                            Sensoren verbaut, die die Zustände unterschiedlicher
                            Objekte vor Ort in Echtzeit messen. So können
                            beispielsweise die Belegung von Parkplätzen, die
                            Temperatur in Räumen, Funktionalität von technischen
                            Geräten und viele weitere Werte konstant überwacht
                            werden. In der Anwendung werden die Messergebnisse
                            der Sensoren grafisch dargestellt, um daraus
                            Handlungen abzuleiten und ein umfassendes Bild des
                            gesamten Objekts zu liefern.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto01.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <p class="small-tile-text">
                            <span class="subheadline1"
                              >Aufbau der Anwendung</span
                            >
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            Das Hauptmenü ist in der Desktop-Ansicht am linken
                            Bildschirmrand verfügbar. In der mobilen
                            Smartphone-Ansicht wird es oben rechts angezeigt.<br />
                            Das Menü zeigt sechs Symbole, über die Sie die
                            verschiedenen Funktionsbereiche aufrufen:<br />
                            - Parkhäuser <br />
                            - Reporting<br />
                            - Benutzerhandbuch<br />
                            - Einstellung Baumstruktur<br />
                            - Benutzereinstellungen<br />
                            - Ausloggen<br />
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto02.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <p class="small-tile-text">
                            <span class="subheadline1"
                              >Funkionsumfang und -bereiche</span
                            >
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            <span class="subheadline2">
                              Parkhäuser:
                            </span>
                            Um den Zustand eines Objekts zu prüfen, wählen Sie
                            im 2. Menü auf der linken Seite zunächst einen
                            Unterpunkt und dann die gewünschte Anwendung aus.
                            Sie können die Auswahl mit dem &quot;x&quot; im
                            entsprechenden Menü-Element wieder rückgängig
                            machen. Die Struktur Ihrer IoT-Anwendung wird unter
                            dem Menü-Punkt &quot;Einstellung Baumstruktur&quot;
                            eingestellt und verwaltet. Sollten Sie einen
                            Unterpunkt oder eine Anwendung nicht vorfinden,
                            wenden Sie sich bitte an den Support:
                            <a href="mailto:support@digimondo.de">
                              support@digimondo.de</a
                            >. Nachdem Sie eine Anwendung ausgewählt haben,
                            färbt sich das Logo oben links farbig ein und Sie
                            haben in den verschiedenen Kacheln einen Überblick
                            über die verbauten Sensoren und deren Zustände.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto03.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            <span class="subheadline2">
                              Kachel-Ansicht:
                            </span>
                            Die Kacheln fassen jeweils Sensoren vom gleichen Typ
                            pro Anwendung zusammen. Ist auf einer Kachel ein
                            grüner Haken zu sehen, hat keiner der Sensoren einen
                            Alarm ausgelöst.
                            <br />
                            Sobald mindestens ein Sensor einen Alarm auslöst,
                            beinhaltet die entsprechende Kachel ein rotes Kreuz
                            sowie die Information, wo welcher Alarm aus welchem
                            Grund ausgelöst wurde.
                            <br />
                            Navigations-Optionen:<br />
                            (1) Ein Klick auf die Schaltflächen „Kartenansicht“
                            und „Alarm-Karte“ öffnet die 3D-Karte mit entweder
                            allen Sensoren oder nur den Sensoren im
                            Alarmzustand.<br />
                            (2) Ein Klick auf einen Alarm öffnet die 3D-Karte,
                            in der die Position des entsprechenden Sensors
                            angezeigt wird.<br />
                            (3) Ein Klick auf die Überschrift einer Kachel
                            öffnet die 3D-Karte und zeigt alle Sensoren des
                            entsprechenden Typs an.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto04.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            <span class="subheadline2">
                              Tabellen-Ansicht:
                            </span>
                            Über den Kipp-Schalter oben rechts, können Sie von
                            der Kachel-Ansicht auf die Tabellen-Ansicht
                            umschalten. Die Tabellen-Ansicht ist in zwei
                            untereinander angeordnete Bereiche aufgeteilt. Im
                            oberen Bereich werden alle Alarm-Meldungen der
                            Anwendung angezeigt, die nach Sensor-Typ sortiert
                            sind. Im unteren werden alle Sensoren der Anwendung
                            inklusive der Sensoren mit Alarmmeldung angezeigt.
                            Auch diese Tabelle ist nach Sensor-Typ sortiert.
                            Navigations-Optionen:
                            <br />
                            (1) Ein Klick auf die Schaltflächen „Kartenansicht“
                            und „Alarm-Karte“ öffnet die Karte mit entweder
                            allen Sensoren oder nur den Sensoren im
                            Alarmzustand.
                            <br />
                            (2) Ein Klick auf eine Tabellenzeile öffnet die
                            3D-Karte, auf der der entsprechende Sensor angezeigt
                            wird.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto05.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            <span class="subheadline2">
                              Reporting:
                            </span>
                            Der Funktionsbereich Reporting führt Sie über eine
                            große Schaltfläche in der Mitte in den Teil der
                            Applikation, in dem Berichte und Auswertungen
                            erstellt und eingesehen werden können. Hier ist aus
                            Sicherheitsgründen eine separate Anmeldung
                            notwendig. In der Berichtsapplikation können
                            Auswertungen über beliebig definierbare Zeiträume,
                            Sensor-Typen und Messwerte erstellt werden.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto09.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            <span class="subheadline2">
                              Einstellung Baumstruktur:
                            </span>
                            Die Einstellung Baumstruktur wird in einer
                            Baumdarstellung angezeigt. Hier können Anwendungen
                            und Kind-Elemente mit den entsprechenden
                            Schaltflächen hinzugefügt oder gelöscht werden.
                            <br />
                            Die Nutzung dieses Bereichs setzt bestimmte
                            Berechtigungen voraus.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto06.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            <span class="subheadline2">
                              Benutzereinstellungen:
                            </span>
                            <br />
                            In diesem Teil der Applikation können Sie Ihre
                            Nutzereinstellungen und die Darstellung der 3D-
                            Karte verändern. <br />
                            Die 3D-Karte kann in unterschiedlichen
                            Farbeinstellungen und Kontrasten dargestellt werden:
                            hell, dunkel, monochrom oder farbig mit
                            zusätzlichen, nützlichen Kartendetails. Klicken Sie
                            auf die &quot;Speichern&quot;-Schaltfläche, um Ihre
                            Einstellungen zu sichern.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto07.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text">
                            <span class="subheadline2">
                              Aktive Benachrichtigungen:
                            </span>
                            Die Anwendung verfügt über eine System-Komponente,
                            die Alarme und Warnungen in Form von
                            Benachrichtigungen an zuvor definierte
                            Nutzer(-gruppen) versendet.
                            <br />
                            Die Benachrichtigungen werden in Form von Emails und
                            SMS-Kurznachrichten versendet. Diese Funktion spielt
                            sich im Hintergrund ab und kann in dieser
                            Nutzerschnittstelle nicht eingesehen oder
                            eingestellt werden.
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p class="small-tile-text text-center">
                            <img
                              src="../assets/contipark/bildschirmfoto08.png"
                              alt=""
                              class="manual-images"
                            />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
